export const irregulars = [
	'awoken',
	'awoke',
	'beaten',
	'beat',
	'begun',
	'began',
	'bent',
	'bitten',
	'bit',
	'bled',
	'blown',
	'blew',
	'broken',
	'broke',
	'brought',
	'built',
	'bought',
	'caught',
	'chosen',
	'chose',
	'dealt',
	'done',
	'did',
	'drawn',
	'drew',
	'driven',
	'drove',
	'eaten',
	'ate',
	'fed',
	'felt',
	'fought',
	'found',
	'forbidden',
	'forbade',
	'forgotten',
	'forgot',
	'forgiven',
	'forgave',
	'frozen',
	'froze',
	'gotten',
	'got',
	'given',
	'gave',
	'ground',
	'grinded',
	'hung',
	'heard',
	'hidden',
	'hid',
	'hit',
	'held',
	'hurt',
	'kept',
	'known',
	'knew',
	'laid',
	'led',
	'let',
	'lost',
	'made',
	'meant',
	'met',
	'paid',
	'proven',
	'proved',
	'put',
	'read',
	'ridden',
	'rode',
	'rung',
	'rang',
	'run',
	'ran',
	'said',
	'seen',
	'saw',
	'sold',
	'sent',
	'shaken',
	'shook',
	'shaved',
	'shot',
	'shown',
	'shut',
	'sung',
	'sunk',
	'slain',
	'slew',
	'slid',
	'spoken',
	'spoke',
	'spent',
	'spun',
	'split',
	'spread',
	'stolen',
	'stole',
	'struck',
	'swept',
	'swung',
	'taken',
	'took',
	'taught',
	'torn',
	'tore',
	'told',
	'thought',
	'thrown',
	'threw',
	'undergone',
	'underwent',
	'understood',
	'upset',
	'woken',
	'woke',
	'worn',
	'wore',
	'won',
	'withdrawn',
	'withdrew',
	'written',
	'wrote',
	'been',
	'born',
	'become',
	'beset',
	'bet',
	'bid',
	'bidden',
	'bound',
	'bred',
	'broadcast',
	'burnt',
	'burst',
	'cast',
	'clung',
	'come',
	'cost',
	'crept',
	'cut',
	'dug',
	'dived',
	'dreamt',
	'drunk',
	'fallen',
	'fit',
	'fled',
	'flung',
	'flown',
	'foregone',
	'forsaken',
	'gone',
	'grown',
	'knelt',
	'knit',
	'leapt',
	'learnt',
	'left',
	'lent',
	'lain',
	'lighted',
	'misspelt',
	'mistaken',
	'mown',
	'overcome',
	'overdone',
	'overtaken',
	'overthrown',
	'pled',
	'quit',
	'rid',
	'risen',
	'sawn',
	'sought',
	'set',
	'sewn',
	'shaven',
	'shorn',
	'shed',
	'shone',
	'shod',
	'shrunk',
	'sat',
	'slept',
	'slung',
	'slit',
	'smitten',
	'sown',
	'sped',
	'spilt',
	'spit',
	'sprung',
	'stood',
	'stuck',
	'stung',
	'stunk',
	'stridden',
	'strung',
	'striven',
	'sworn',
	'swollen',
	'swum',
	'thrived',
	'thrust',
	'trodden',
	'upheld',
	'woven',
	'wed',
	'wept',
	'wound',
	'withheld',
	'withstood',
	'wrung'
];
  